import React, {Component} from 'react'
import SectionWrapper from "../../sectionwrapper.component.jsx";

class ProjectDescriptionContentSection extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            className: this.props.className || '',
            section: this.props.section || null,
            variables: this.props.variables || null,
            editable: this.props.editable || false,
            edition: this.props.edition || false,
            onEdit: this.props.onEdit || function(){},
            id: this.props.id || '',
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            section: nextProps.section || null,
            variables: nextProps.variables || null,
            id: nextProps.id || '',
        })
    }

    render() {
        if (!this.state.variables) {
            return <div />
        }
        return (
            <SectionWrapper
                id={this.state.id}
                section={this.state.section}
                onEdit={this.state.onEdit}
                editable={this.state.editable}
                variables={this.state.variables}
            >
                <div className="col-12 py-2 rich-text">
                    <div dangerouslySetInnerHTML={{__html: this.state.variables.project.description}} />
                </div>
            </SectionWrapper>
        );
    }
}

export default ProjectDescriptionContentSection


// WEBPACK FOOTER //
// ./src/template/sections/content/project-description/section.component.jsx